export interface SuccessStory {
  id: number;
  name: string;
  location: string;
  age: number;
  image: string;
  beforeRole: string;
  afterRole: string;
  quote: string;
  program: string;
  programColor: string;
  tags: string[];
  storyText: string;
  duration: string;
}

export const successStories: SuccessStory[] = [
  {
    id: 1,
    name: "אחמד חסן",
    location: "אום אל פחם",
    age: 28,
    image: "https://readdy.ai/api/search-image?query=confident%20young%20arab%20man%20professional%20portrait%2C%20warm%20smile%2C%20wearing%20casual%20button%20shirt%2C%20soft%20beige%20studio%20background%2C%20natural%20lighting%2C%20friendly%20expression%2C%20high%20quality%20headshot%20photo&width=120&height=120&seq=ss-ahmad&orientation=squarish",
    beforeRole: "מובטל",
    afterRole: "מנהל/ת שיווק דיגיטלי",
    quote: "מתר נתנה לי את הכלים והביטחון לצאת לשוק העבודה. היום אני מנהל קמפיינים בחברת הייטק מובילה.",
    program: "ליווי תעסוקתי",
    programColor: "#EDE9FE",
    tags: ["הייטק", "שיווק דיגיטלי", "אום אל פחם"],
    storyText: "אחמד הגיע למתר אחרי שנתיים של חיפושי עבודה ללא הצלחה. דרך תוכנית הליווי התעסוקתי קיבל הכשרה בשיווק דיגיטלי, ליווי אישי בכתיבת קורות חיים, ותרגול ראיונות עבודה. תוך 4 חודשים התקבל לתפקיד ראשון כמנהל קמפיינים, וכיום הוא מוביל צוות של 3 אנשים.",
    duration: "4 חודשים",
  },
  {
    id: 2,
    name: "סמירה אבו ריא",
    location: "רהט",
    age: 34,
    image: "https://readdy.ai/api/search-image?query=confident%20arab%20woman%20professional%20portrait%2C%20warm%20genuine%20smile%2C%20wearing%20elegant%20blouse%2C%20soft%20beige%20studio%20background%2C%20natural%20lighting%2C%20empowered%20expression%2C%20high%20quality%20headshot%20photo&width=120&height=120&seq=ss-samira&orientation=squarish",
    beforeRole: "עובדת ניקיון",
    afterRole: "בעלת עסק קייטרינג",
    quote: "תמיד חלמתי לפתוח עסק משלי. מתר עזרו לי להפוך את החלום למציאות — מהתכנית העסקית ועד ללקוח הראשון.",
    program: "ליווי עסקי",
    programColor: "#FEF9C3",
    tags: ["עסקים", "קייטרינג", "רהט"],
    storyText: "סמירה עבדה שנים כעובדת ניקיון אך תמיד אהבה לבשל. במסגרת תוכנית הליווי העסקי של מתר, קיבלה ליווי בבניית תכנית עסקית, סיוע בהשגת מימון ראשוני, וליווי שיווקי. היום היא מנהלת עסק קייטרינג מצליח עם 6 עובדים קבועים ולקוחות קבועים בכל האזור.",
    duration: "8 חודשים",
  },
  {
    id: 3,
    name: "יוסף כהן",
    location: "ראשון לציון",
    age: 42,
    image: "https://readdy.ai/api/search-image?query=confident%20middle%20aged%20jewish%20man%20professional%20portrait%2C%20warm%20smile%2C%20wearing%20polo%20shirt%2C%20soft%20beige%20studio%20background%2C%20natural%20lighting%2C%20friendly%20approachable%20expression%2C%20high%20quality%20headshot%20photo&width=120&height=120&seq=ss-yosef&orientation=squarish",
    beforeRole: "נהג מונית",
    afterRole: "טכנאי מחשבים",
    quote: "בגיל 42 חשבתי שכבר מאוחר מדי לשינוי. מתר הוכיחו לי שתמיד יש זמן — היום אני עובד בתחום שאני אוהב.",
    program: "ליווי תעסוקתי",
    programColor: "#EDE9FE",
    tags: ["טכנולוגיה", "מחשבים", "ראשון לציון"],
    storyText: "יוסף עבד כנהג מונית מעל 15 שנה אך תמיד התעניין במחשבים. דרך מתר קיבל הכשרה מקצועית כטכנאי מחשבים, ליווי במציאת מקום התמחות, ותמיכה במעבר המקצועי. תוך 6 חודשים התקבל כטכנאי במרכז שירות גדול, וכיום הוא מתכנן להתקדם לתפקידי ניהול.",
    duration: "6 חודשים",
  },
  {
    id: 4,
    name: "נור אבו ג'בל",
    location: "טירה",
    age: 24,
    image: "https://readdy.ai/api/search-image?query=young%20confident%20arab%20woman%20professional%20portrait%2C%20bright%20smile%2C%20wearing%20modern%20casual%20top%2C%20soft%20beige%20studio%20background%2C%20natural%20lighting%2C%20youthful%20energetic%20expression%2C%20high%20quality%20headshot%20photo&width=120&height=120&seq=ss-noor&orientation=squarish",
    beforeRole: "סטודנטית",
    afterRole: "מעצבת UX/UI",
    quote: "הסדנאות של מתר פתחו לי עולם שלם של אפשרויות. היום אני עובדת מרחוק לחברה בינלאומית.",
    program: "הכשרות מקצועיות",
    programColor: "#DCFCE7",
    tags: ["עיצוב", "UX/UI", "טירה"],
    storyText: "נור סיימה תואר ראשון אך לא מצאה משרה בתחום העיצוב. השתתפה בסדנת UX/UI של מתר שכללה לימודים מעשיים, בניית תיק עבודות, וליווי אישי. תוך 3 חודשים מסיום ההכשרה התקבלה לתפקיד מעצבת בחברת סטארטאפ, וכיום היא עובדת מרחוק לחברה בינלאומית עם תנאים מעולים.",
    duration: "3 חודשים",
  },
  {
    id: 5,
    name: "מוחמד אבו ליל",
    location: "לוד",
    age: 31,
    image: "https://readdy.ai/api/search-image?query=confident%20young%20arab%20man%20professional%20portrait%2C%20friendly%20smile%2C%20wearing%20smart%20casual%20jacket%2C%20soft%20beige%20studio%20background%2C%20natural%20lighting%2C%20determined%20expression%2C%20high%20quality%20headshot%20photo&width=120&height=120&seq=ss-mohammad&orientation=squarish",
    beforeRole: "מחסנאי",
    afterRole: "מפתח Full Stack",
    quote: "הקורס תכנות של מתר שינה את חיי. מהמחסן למשרד הייטק — זה היה מסע מדהים.",
    program: "הכשרות מקצועיות",
    programColor: "#DCFCE7",
    tags: ["הייטק", "פיתוח", "לוד"],
    storyText: "מוחמד עבד כמחסנאי במשך 5 שנים. דרך מתר נרשם לקורס פיתוח Full Stack אינטנסיבי שכלל לימודים, פרויקטים מעשיים, וחיבור לחברות מגייסות. תוך 5 חודשים מסיום הקורס התקבל כמפתח junior בחברת הייטק, וכיום הוא מפתח בכיר עם 3 שנות ניסיון.",
    duration: "5 חודשים",
  },
  {
    id: 6,
    name: "רינה דוידוב",
    location: "אשדוד",
    age: 38,
    image: "https://readdy.ai/api/search-image?query=confident%20jewish%20woman%20professional%20portrait%2C%20warm%20motherly%20smile%2C%20wearing%20elegant%20top%2C%20soft%20beige%20studio%20background%2C%20natural%20lighting%2C%20kind%20expression%2C%20high%20quality%20headshot%20photo&width=120&height=120&seq=ss-rina&orientation=squarish",
    beforeRole: "אם בחופשת לידה",
    afterRole: "יועצת משכנתאות",
    quote: "אחרי 4 שנים בבית, חשבתי שאף אחד לא ירצה לקבל אותי. מתר נתנו לי ביטחון והכשרה — היום אני עצמאית עם לקוחות משלי.",
    program: "ליווי עסקי",
    programColor: "#FEF9C3",
    tags: ["פיננסים", "ייעוץ", "אשדוד"],
    storyText: "רינה יצאה לחופשת לידה ארוכה וחששה לחזור לשוק העבודה. דרך מתר קיבלה הכשרה כיועצת משכנתאות, ליווי בפתיחת עסק עצמאי, ותמיכה שיווקית. היום היא מנהלת משרד ייעוץ משכנתאות עצמאי עם צוות של 2 יועצים, ועוזרת למשפחות רבות לממש את חלום הדירה.",
    duration: "10 חודשים",
  },
];
